import { render, staticRenderFns } from "./symptom_manifestation.vue?vue&type=template&id=7165eb48&scoped=true"
import script from "./symptom_manifestation.vue?vue&type=script&lang=js"
export * from "./symptom_manifestation.vue?vue&type=script&lang=js"
import style0 from "./symptom_manifestation.vue?vue&type=style&index=0&id=7165eb48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7165eb48",
  null
  
)

export default component.exports